import React from 'react';
// No external CSS imports needed, all styles are internal

const toolLogos = [
  { name: "Metasploit", image: "https://skillsuprise.com/data/cyberPDF/tools/Metasploit.png" },
  { name: "BurpSuite", image: "https://skillsuprise.com/data/cyberPDF/tools/brupsuite.png" },
  { name: "Wireshark", image: "https://skillsuprise.com/data/cyberPDF/tools/wireshark.png" },
  { name: "Nmap", image: "https://skillsuprise.com/data/cyberPDF/tools/Nmap.png" },
  { name: "Autopsy", image: "https://skillsuprise.com/data/cyberPDF/tools/autospy.png" },
  { name: "Ettercap", image: "https://skillsuprise.com/data/cyberPDF/tools/ettercap.png" },
  { name: "SQLMap", image: "https://skillsuprise.com/data/cyberPDF/tools/sql.png" },
  
  { name: "Aircrack-ng", image: "https://skillsuprise.com/data/cyberPDF/tools/aircrack.png" },
  { name: "Snort", image: "https://skillsuprise.com/data/cyberPDF/tools/snort.png" },
  { name: "John the Ripper", image: "https://skillsuprise.com/data/cyberPDF/tools/John the ripper.png" },
   { name: "Hydra", image: "https://skillsuprise.com/data/cyberPDF/tools/hydra.png" },
 
  { name: "Acunetix", image: "https://skillsuprise.com/data/cyberPDF/tools/Acunetix.png" },
  { name: "Nikto", image: "https://skillsuprise.com/data/cyberPDF/tools/Nikto.png" },
  { name: "Wifite", image: "https://skillsuprise.com/data/cyberPDF/tools/wifite.png" },
  { name: "Netcat", image: "https://skillsuprise.com/data/cyberPDF/tools/netcat.png" },
  { name: "OpenVAS", image: "https://skillsuprise.com/data/cyberPDF/tools/openVAS.png" },
  { name: "Nessus", image: "https://skillsuprise.com/data/cyberPDF/tools/Nessus.png" },
   { name: "Medusa", image: "https://skillsuprise.com/data/cyberPDF/tools/medusa.png" },

  { name: "Angry IP Scanner", image: "https://skillsuprise.com/data/cyberPDF/tools/Angry IP.png" },
  { name: "BeEF", image: "https://skillsuprise.com/data/cyberPDF/tools/beEF.png" },
    { name: "Maltego", image: "https://skillsuprise.com/data/cyberPDF/tools/maltego.png" },

  { name: "OWASP Zap", image: "https://skillsuprise.com/data/cyberPDF/tools/OWASP ZAP.png" },
  { name: "Fern", image: "https://skillsuprise.com/data/cyberPDF/tools/Fern Wifi Cracker.png" },
];


const internalCSS = `
  /* --- Main Page Container --- */
  .hacking-tools-page {
    background-color: #f8f9fa; /* Light grey background for the whole page */
   
  }

  /* --- Top Banner Section --- */
  .top-banner-section {
    position: relative;
    width: 100%;
    height: 300px; /* Fixed height for the banner */
    overflow: hidden;
    display: flex;
    align-items: center; /* Vertically center content */
    background-color: #000; /* Fallback background */
  }

  .banner-background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; /* Cover the entire area */
    object-position: top center; /* Focus on the top part of the image */
    opacity: 0.6; /* Slight dimming to make text stand out */
  }

  .banner-content {
    position: relative; /* Ensure content is above the image */
    z-index: 1; /* Bring text to front */
    padding: 2rem 1rem;
    color: #fff;
    text-align: left;
    max-width: 960px; /* Limit width for large screens */
 
  }

  .banner-title {
    font-family: 'Poppins', 'Open Sans', sans-serif;
    font-size: 2.8rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 0;
    /* Simulate the yellow highlight as seen in the screenshot */
    background: 000000ff;
    display: inline; /* Keep gradient with text */
    padding-right: 10px;
    padding-left: 10px;
  }

  /* --- Logos Grid Section --- */
  .logos-grid-section {
    padding: 3rem 1rem;
    background-color: #fff; /* White background for the grid area */
    border-bottom: 1px solid #e9ecef; /* Subtle divider */
  }

  .logo-item {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff; /* Ensure logo area is white */
    padding: 1rem;
    
    min-height: 80px; /* Ensures consistent height for grid items */
  }

  .logo-item img {
    max-width: 135% !important;
    max-height: 80px; /* Limit logo height */
    object-fit: contain; /* Ensure logo is fully visible */
  }

  /* --- Button Section --- */
  .button-section {
    padding: 1rem 1rem;
    text-align: center;
    background-color: #f8f9fa; /* Match page background */
  }

  .btn-premium-tools {
    /* Exact styling from the previous button request */
    background-color: #0b5ed7; /* Deep, vibrant blue */
    color: #fff;
    font-family: 'Poppins', 'Open Sans', sans-serif; 
    font-size: 1.2rem;
    font-weight: 600; 
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.6);
    border: none;
    border-radius: 50px; 
    padding: 0.75rem 2.5rem; 
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
    white-space: nowrap; /* Prevent text wrapping on button */
  }

  .btn-premium-tools:hover {
    background-color: #0a58ca;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  /* --- RESPONSIVE OVERRIDES --- */
  @media (max-width: 1199.98px) { /* Adjust for smaller desktops/large tablets */
    .banner-title {
      font-size: 2.4rem;
    }
  }

  @media (max-width: 991.98px) { /* Tablet view */
    .top-banner-section {
      height: 130px;
    }
    .banner-title {
      font-size: 2rem;
    }
    .logos-grid-section {
      padding: 2rem 0.5rem;
    }
    .logo-item {
      min-height: 80px;
    }
  }

  @media (max-width: 767.98px) { /* Mobile view */
    .top-banner-section {
      height: 130px; /* Shorter banner on mobile */
    }
    .banner-title {
      font-size: 1.2rem;


      background: linear-gradient(to right, #000000ff 0%, #000000ff 80%, transparent 80%, transparent 100%); /* Adjust gradient for shorter text */
    }
    .logos-grid-section {
      padding: 1.5rem 0.25rem;
    }
    .logo-item {
      min-height: 75px;
      padding: 0.5rem;
    }
    .logo-item img {
      max-height: 80px;
    }
    .btn-premium-tools {
      font-size: 0.9rem;
      padding: 0.5rem 1.5rem;
    }
  }

  /* REMOVED: The specific override for extra-small phones was removed 
    to allow row-cols-4 to apply.
  */
`;

const HackingToolsPage = () => {
  return (
    <>
      <style>{internalCSS}</style>

      <div className="hacking-tools-page">
        {/* --- 1. Top Banner Section --- */}
        <div className="top-banner-section">
          {/* Placeholder for the background image with the person */}
          <img 
            src="https://skillsuprise.com/data/cyberPDF/chapters/chapter1.png" 
            alt="Hacking Tools Background" 
            className="banner-background-image" 
          />
          <div className="banner-content">
            <h1 className="banner-title">
           
<>
  <span style={{ color: '#ffc107' }}>Master 100+ Premium</span>
  <br />
  Hacking Tools Practically
</>

            </h1>
          </div>
        </div>

        {/* --- 2. Tool Logos Grid --- */}
        <div className="logos-grid-section">
          <div className="container">
            {/*
              --- THIS IS THE CHANGE ---
              - row-cols-4: 4 columns on ALL screens (mobile, tablet)
              - row-cols-lg-5: 5 columns on desktop (>=992px) - Matches your image
            */}
            <div className="d-flex flex-wrap row-cols-4 row-cols-lg-5 g-3 g-md-4">
              {toolLogos.map((tool, index) => (
                <div className="col" key={index}>
                  <div className="logo-item">
                    <img src={tool.image} alt={tool.name} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* --- 3. Bottom Button --- */}
        <div className="button-section">
          <button className="btn-premium-tools">
            +100 More Premium Hacking Tools
          </button>
        </div>
      </div>
    </>
  );
};

export default HackingToolsPage;